import instance from './instance';

export function get(url, params, config = {}) {
  return instance(url, { method: 'GET', params, ...config });
}

export function post(url, data, config = {}) {
  return instance(url, { method: 'POST', data, ...config });
}

export function deleteMethod(url, data, config = {}) {
  return instance(url, { method: 'DELETE', data, ...config });
}
